import React, { useContext } from 'react';
import { ReactComponent as DownloadIos } from '../../../../../../../resources/images/svg/downloadIos.svg';
import { ReactComponent as DownloadAndroid } from '../../../../../../../resources/images/svg/downloadAndroid.svg';
import useTranslation from '../../../../../../hooks/translation/useTranslation';
import { TranslationContext } from '../../../../../../contexts/TranslationContext';
import MobileApp from '../../../../../../../resources/images/png/mobileApp.png';
import MobileAppEn from '../../../../../../../resources/images/png/mobileApp_en.png';

function AppAdvertisement() {
  const { trans } = useTranslation();
  const { currentLanguage } = useContext(TranslationContext);
  const mobileAppImage = currentLanguage === 'en' ? MobileAppEn : MobileApp;

  return (
    <div className="hidden lg:flex relative container h-[700px] justify-center">
      <div className="absolute z-[2] bottom-0 left-0 bg-primary w-[67%] h-[340px] rounded-3xl flex flex-col justify-center gap-5 px-20 py-12">
        <p className="m-0 text-white text-base">
          {trans('download-application')}
        </p>
        <div className="flex gap-4">
          <a href="https://apps.apple.com/ge/app/georgian-railway/id6746049057" target="_blank" rel="noopener noreferrer">
            <DownloadIos />
          </a>
          <a href="https://play.google.com/store/apps/details?id=ge.railway.mobile" target="_blank" rel="noopener noreferrer">
            <DownloadAndroid />
          </a>
        </div>
      </div>
      <img
        className="absolute z-[3] top-0 trans"
        src={mobileAppImage}
        alt="mobile app"
        width="35%"
        height={700}
      />
    </div>
  );
}

export default AppAdvertisement;
